export default "__VITE_ASSET__bad9bcfb__"